import { render, staticRenderFns } from "./RouteConfigInfEdit.vue?vue&type=template&id=c87410f6&scoped=true&"
import script from "./RouteConfigInfEdit.vue?vue&type=script&lang=js&"
export * from "./RouteConfigInfEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87410f6",
  null
  
)

export default component.exports